import React from "react";

type PaymentIframeProps = {
	iframeUrl: string;
};

export const PaymentIframe: React.FC<PaymentIframeProps> = ({
	iframeUrl,
}: PaymentIframeProps) => {
	if (!iframeUrl) return null;

	return (
		<div id='payment-iframe-container'>
			<iframe src={iframeUrl}></iframe>
		</div>
	);
};
